import api from '@/services/api'

export default class CohortAPI {
  static COHORTS_ENDPOINT = 'cohorts'
  /**
   * Initialize a `CohortAPI` instance.
   *
   * @param {class} cls  The class to use to create application objects.
   **/
  constructor(cls) {
    this.cls = cls
  }

  /**
   * Factory method to create a new instance of `CohortAPI`.
   *
   * @param {class} cls      The class to use to create application objects.
   **/
  static create(cls) {
    return new CohortAPI(cls)
  }

  /**
   * Get the API Client.
   */
  get client() {
    return api.getApiClient()
  }

  /**
   * Retrieve one application from the API.
   *
   * @param {String} cohortId  Unique ID of the application to retrieve.
   */
  get(cohortId) {
    const url = `${CohortAPI.COHORTS_ENDPOINT}/${cohortId}/`
    return this.client.get(url).then(response => this.cls.fromAPI(response.data))
  }

  /**
   * Get all application through the API.
   *
   *
   */
  list() {
    const url = `${CohortAPI.COHORTS_ENDPOINT}/`
    var thisData = this.client.get(url).then(response => response.data)

    thisData = thisData.then(data => {
      // To Do, add data.results instead of data when you add pagination
      data.results = data.results.map(this.cls.fromAPI)
      return data
    })
    return thisData
  }

  activeID() {
    const url = `${CohortAPI.COHORTS_ENDPOINT}/active_id/`
    const result = this.client.get(url).then(response => response.data.id)
    return result
  }

  /**
   * Update a application through the API.
   *
   * @param {application} application data to send to the API.
   */
  update(application, fields = [], excludeFields = []) {
    const url = `${CohortAPI.COHORTS_ENDPOINT}/${application.id}/`
    const data = this.cls.toAPI(application, fields, excludeFields)
    return this.client.patch(url, data).then(response => this.cls.fromAPI(response.data))
  }
}
